var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49999 13.4167C3.17916 13.4167 2.90451 13.3024 2.67604 13.074C2.44756 12.8455 2.33333 12.5708 2.33333 12.25V5.83334C2.33333 5.51251 2.44756 5.23786 2.67604 5.00939C2.90451 4.78091 3.17916 4.66668 3.49999 4.66668H5.24999V5.83334H3.49999V12.25H10.5V5.83334H8.74999V4.66668H10.5C10.8208 4.66668 11.0955 4.78091 11.324 5.00939C11.5524 5.23786 11.6667 5.51251 11.6667 5.83334V12.25C11.6667 12.5708 11.5524 12.8455 11.324 13.074C11.0955 13.3024 10.8208 13.4167 10.5 13.4167H3.49999ZM6.41666 9.33334V2.81459L5.48333 3.74793L4.66666 2.91668L6.99999 0.583344L9.33333 2.91668L8.51666 3.74793L7.58333 2.81459V9.33334H6.41666Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.57dede319a5707e5845c99a8557cc242.svg";
export { ForwardRef as ReactComponent };